import { apiClient } from '../client';

export interface WorkspaceWhatsApp {
  business_account_id: string;
  name: string;
  phone_number: string | null;
}

export interface Workspace {
  id: string;
  name: string;
  is_default: boolean;
  organization_id: string;
  lead_form_layout?: Record<string, unknown> | string | null;
  image?: string | null;
  business_account_id: string | null;
  whatsapp: WorkspaceWhatsApp | null;
}

export interface WorkspaceDataSummary {
  counts: Record<string, number>;
  hasAiKnowledge: boolean;
  hasCustomFields: boolean;
  brandWebsiteCount: number;
  hasAnyData: boolean;
}

export interface WorkspaceDataSummaryResponse extends WorkspaceDataSummary {
  businessAccount: { id: string; name: string } | null;
}

export interface WorkspaceMoveCandidate {
  id: string;
  name: string;
}

export const workspacesApi = {
  async getAll() {
    return apiClient.get<Workspace[]>('/workspaces');
  },

  async create(data: { name: string }) {
    return apiClient.post<Workspace>('/workspaces', data);
  },

  async getById(id: string) {
    return apiClient.get<Workspace>(`/workspaces/${id}`);
  },

  async update(id: string, data: { name?: string; is_default?: boolean; image?: string | null }) {
    return apiClient.put<Workspace>(`/workspaces/${id}`, data);
  },

  async updateLeadFormLayout(id: string, layout: unknown | null) {
    return apiClient.put<Workspace>(`/workspaces/${id}/lead-form-layout`, {
      lead_form_layout: layout,
    });
  },

  async getDataSummary(id: string) {
    return apiClient.get<WorkspaceDataSummaryResponse>(`/workspaces/${id}/data-summary`);
  },

  async delete(id: string, data?: { move_to_workspace_id?: string }) {
    return apiClient.delete<{ id: string; deleted: true; moved: Record<string, number> }>(`/workspaces/${id}`, {
      body: data,
    });
  },
};
